<template>
  <div v-loading="loading">
    <iframe
        ref="mainIframe"
        :src="iframeUrl"
        width="100%"
        :style="{'height': documentClientHeight-115 + 'px'}"
        frameborder="0"
        scrolling="yes"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      loading: true,
      mainToken:'', // token
      isIframe:true, // 标识
      isBigdata:false,
      // origin:'http://192.168.1.91:9021', // 本地地址前缀
      // origin:'http://172.16.26.190:30231', // 内网地址前缀
      origin:'', // 外网地址前缀
      url:'/home', // 要跳转的指定路由位置
  }
  },
  computed: {
    // 获取高度，解决iframe高度固定150的问题
    documentClientHeight: {
      get () { return this.$store.state.common.documentClientHeight },
      set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
    },
    iframeUrl:{
      get(){
        return encodeURI(`${this.origin}/redirect?token=${this.mainToken}&microApp=${this.isIframe}&isBigdata=${this.isBigdata}&redirectUrl=${this.url}`)
      }
    }
  },
  created() {
    this.mainToken = this.$cookie.get('access_token');
    this.origin=process.env.VUE_APP_entInfo

  },
  mounted() {
    const iframe = this.$refs.mainIframe;
    // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
    if (iframe.attachEvent) { // IE
      iframe.attachEvent('onload', () => { this.loading = false; });
    } else { // 非IE
      iframe.onload =  () => { this.loading = false; };
    }


  }
}
</script>

<style lang="scss" scoped>

</style>
